import React from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router';

import { useTimeModal } from '../../Components/TimeModal/TimeModalContext';

import FileUploadField from '../../Components/FileUploadField';
import Loading from '../../Components/Loading';
import LegalNotice from '../../Components/Legal/LegalNotice';

import Modal from '../Modal';
import FileViewerModal from '../FileViewerModal';

import IconContainer from '../../Components/IconContainer';
import { ReactComponent as EyeIcon } from '../../icons/eye.svg';
import { ReactComponent as DownloadIcon } from '../../icons/download.svg';

const PDConsent = ({ isSignature }) => {
    const navigate = useNavigate();
    const { openTimeModal } = useTimeModal();

    const [templateConsentFileId, setTemplateConsentFileId] = React.useState(null);
    const [files, setFiles] = React.useState({
        consent: null,
    });
    const [loading, setLoading] = React.useState(true);
    const [status, setStatus] = React.useState('');

    React.useEffect(() => {
        setLoading(true);

        axios.get('/api/get-template-consent-file-id')
        .then((response) => {
            setTemplateConsentFileId(response.data.file_id);
        }).catch((error) => {
            console.error(error);
        }).finally(() => {
            setLoading(false);
        })
    }, []);

    const handleFileChange = (field) => (e) => {
        const file = e.target.files[0];
        setFiles((prev) => ({
            ...prev,
            [field]: file || null,
        }));
    };

    const handleFileReset = (field) => () => {
        setFiles((prev) => ({
            ...prev,
            [field]: null,
        }));
    };

    const [isFileViewer, setIsFileViewer] = React.useState(false);
    const [currentFileId, setCurrentFileId] = React.useState('');

    const handleSave = () => {
        const token = localStorage.getItem('token');

        setLoading(true);
        
        const formData = new FormData();

        formData.append('fileNameConsent', files.consent?.name || '');
        if (!files.consent) {
            setStatus(<a className='mainLabelError'>Необходимо прикрепить файл</a>);
            return;
        }
        if (files.consent) {
            formData.append('file_consent', files.consent);
        }

        axios.put('/api/upload-personal-data-consent', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${token}`,
            }
        }).then(() => {
            setStatus(<a>Согласие отправлено</a>);
            openTimeModal('Согласие отправлено', 'success');
            navigate('/home');
        }).catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>{`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`}</a>);
        }).finally(() => {
            setLoading(false);
        });
    };

    const handleDownload = async () => {
        try {
        const res = await fetch(`/api/sign-docx-pd-consent`, {
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        });

        if (!res.ok) {
            throw new Error("Ошибка при скачивании");
        }

        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = "Согласие_на_обработку_персональных_данных.docx"; // имя файла при скачивании
        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(url);
        } catch (err) {
        console.error("Ошибка при скачивании файла:", err);
        }
    };

    return (
    <>
        <Modal isOpen={isFileViewer} closeModal={() => setIsFileViewer(false)}>
            <FileViewerModal id={templateConsentFileId} />
        </Modal>
        <div className='panel'>
            <div className='panelHeader'>
                <h2 style={{fontSize: '15px', fontWeight: '500'}}>Прикрепите согласие на обработку персональных данных</h2>
            </div>
            <div className='panelMain'>
                <p className='description'>Для продолжения работы с сервисом необходимо прикрепить согласие на обработку персональных данных. Вы можете скачать шаблон согласия, заполнить его и прикрепить на этой странице.</p>
                <p className='description'>Если у вас уже есть готовый файл согласия, вы можете сразу прикрепить его.</p>

                {templateConsentFileId && 
                <div className='labelInputWrapper'>
                    <a className='label'>Скачать шаблон для самостоятельного заполнения</a>
                    <div className='labelInputRight'>
                        <IconContainer Icon={EyeIcon} onClick={() => setIsFileViewer(true)} size = '18' color = 'blue' className = '' />
                    </div>
                </div>}
                <div className='labelInputWrapper'>
                    <a className='label'>Файл</a>
                    <div className='labelInputRight'>
                        <FileUploadField
                            label='Прикрепить файл'
                            file={files.consent}
                            buttonLabel='Прикрепить файл'
                            onChange={handleFileChange('consent')}
                            onReset={handleFileReset('consent')}
                            allowedFileTypes={['pdf', 'doc', 'docx']}
                            isAlreadyOpened={true}
                            isCloseButton={false}
                        />
                        {/* {(templateConsentFileId && isSignature) &&
                        <>
                            <p className='description' style={{textAlign: 'center'}}>Также можно автоматически сформировать согласие</p>
                            <button type='button' className='button miniButton' onClick={() => handleDownload()}>Скачать сформированное согласие</button>
                        </>} */}
                    </div>
                </div>
            </div>
            <div className='panelBottom'>
                <p style={{width: '70%'}}>{status || <LegalNotice />}</p>
                {loading ? <Loading type='inline' /> : <button className='button black' onClick={handleSave}>Отправить</button>}
            </div>
        </div>
    </>
    )
}

export default PDConsent;